import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ADMIN_FINANCE_PATHS, SETTINGS_TABS } from "../utils/financeTerms";

/** Where an old `/finance-management` link (state.financeTab) now lives. */
function targetFor(financeTab) {
  if (financeTab === "tenants") return ADMIN_FINANCE_PATHS.FinanceReceivables;
  if (financeTab === "bill-to") return `${ADMIN_FINANCE_PATHS.FinanceSettings}?tab=${SETTINGS_TABS.billTo}`;
  if (financeTab === "accounts") return `${ADMIN_FINANCE_PATHS.FinanceSettings}?tab=${SETTINGS_TABS.ourAccounts}`;
  if (financeTab === "customers" || financeTab === "payable") {
    return `${ADMIN_FINANCE_PATHS.FinanceSettings}?tab=${SETTINGS_TABS.clientAccounts}`;
  }
  return ADMIN_FINANCE_PATHS.FinanceInvoices;
}

/** Legacy Finance page: forwards bookmarks and old in-app links to the split finance pages. */
function FinanceManagement() {
  const location = useLocation();
  const financeTab = location.state?.financeTab;
  const filterClientId = location.state?.filterClientId;
  return (
    <Navigate
      to={targetFor(financeTab)}
      replace
      state={filterClientId != null ? { filterClientId } : undefined}
    />
  );
}

export default FinanceManagement;
